<template>
  <!-- BEGIN Page Content -->
  <!-- the #js-page-content id is needed for some plugins to initialize -->
  <div>
    <!-- 表格主体 -->
    <div class="row">
      <div class="col-sm-12">
        <div class="card mb-g">
          <h5 class="card-header bg-white">
            <span>{{ editType }}公司信息</span>
          </h5>
          <div class="card-body">
            <div class="d-flex">
              <div class="form-group  align-items-center">
                <label class="form-label  text-left">公司名称<i style="color:red">*</i>：</label>
                <div class="d-flex">
                  <input v-if="userInfo.company_type != '001' || role == '001edit'" type="text"
                    class="form-control form-control-300" v-model="company.company_name" placeholder="请输入公司名称" />
                  <template v-else>
                    <Interlige ref="Interlige" placeholder="请输入公司名称" url="/exicompany/retrieveall/byname"
                      :value="company.company_name" @targetChanged="queryCmpChange"></Interlige>
                  </template>
                  <button class="btn btn-sm btn-primary" @click="completeInfo">
                    从企查查补全信息
                  </button>
                </div>



                <div style="clear:both;"></div>
              </div>

              <div class="form-group  align-items-center">
                <label class="form-label  text-left">公司缩写：</label>
                <div class="">
                  <input type="text" class="form-control form-control-300" v-model="company.company_name_abb"
                    placeholder="请输入公司缩写" />
                </div>
                <div style="clear:both;"></div>
              </div>
            </div>

            <div class="d-flex">
              <div class="form-group ">
                <label class="form-label form-control-300  text-left">公司logo<label class="form-label "
                    style="font-size: 10px;color: #747a80;">(图片尺寸为1:1)</label>：<button
                    style="margin-bottom:6px;" class="btn btn-sm btn-primary" @click="uploadLogo">
                    上传图片
                  </button></label>
                <div class="">
                  <img :src="company.logo" v-if="company.logo" class="banner-img" />
                </div>
                <div style="clear:both;"></div>
              </div>

              <div class="form-group ">
                <label class="form-label  text-left">公司视频：   <button class="btn btn-sm btn-primary" @click="uploadVideo">
                      上传视频
                    </button></label>
                <div class="">
                  <div style="margin-bottom:6px;">
                 
                    <button v-if="company.video" class="btn btn-danger btn-sm mr-1" @click="del_video()">删除</button>
                    <el-progress v-if="videoProgress != 0 && videoProgress != 100" type="circle" :percentage="videoProgress"
                      :width="40"></el-progress>
                  </div>
                  <video :src="company.video" v-if="company.video" class="banner-img" controls />
                </div>
              </div>
            </div>

            <div class="d-flex">
                  <div class="form-group  align-items-center">
              <label class="form-label  text-left">公司品牌：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.band" placeholder="请输入公司品牌" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">公司标签：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.tags"
                  placeholder="请输入公司标签,多个以逗号分隔" />
              </div>
              <div style="clear:both;"></div>
            </div>
            </div>
            <div class="d-flex">

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">公司省市：</label>
              <div class="d-flex">
                <div class="" style="width:100px">
                  <select class="form-control " :value="getProvinceCode()"
                    @change="onProvinceChange($event)">
                    <option class="form-control " value="000000">省</option>
                    <option class="form-control " v-for="(item, index) of provinces" :value="item.id"
                      :key="index">
                      {{ item.name }}</option>
                  </select>

                  <i></i>
                </div>
                <div class=""  style="width:100px">
                  <select class="form-control " :value="getCityCode()" @change="onCityChange($event)">
                    <option value="000000">市</option>
                    <option v-for="(item, index) of cities" :value="item.id" :key="index">
                      {{ item.name }}</option>
                  </select>
                  <i></i>
                </div>
                <div class=""  style="width:100px">
                  <select class="chosen-select form-control " :value="company.zip"
                    @change="cityChange($event)">
                    <option class="form-control " value="000000">区</option>
                    <option class="form-control " :selected="company.zip == item.id"
                      v-for="(item, index) of districts" :value="item.id" :key="index">
                      {{ item.name }}</option>
                  </select>
                  <i></i>
                </div>
              </div>
            </div>

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">详细地址：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.address"
                  placeholder="请输入公司详细地址" />
              </div>
              <div style="clear:both;"></div>
            </div>
      
            <div class="form-group  align-items-center">
              <label class="form-label  text-left">是否支持自动加入本公司：</label>
              <div class="">
                <el-select  class="selectclass  form-control-300" v-model="company.is_support_join" placeholder="请选择">
                    <el-option label="支持" value="1"></el-option>
                    <el-option label="不支持" value="0"></el-option>
                  </el-select>
             
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div class="d-flex">

        
            <div class="form-group  align-items-center">
              <label class="form-label  text-left">是否为独立展商：</label>
              <div class="">
                <el-select  class="selectclass  form-control-300" v-model="company.show_mode" placeholder="请选择">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                
              </div>
              <div style="clear:both;"></div>
            </div>
            <!-- 
            <div class="form-group row align-items-center">
              <label class="form-label  text-left">展会名称：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.exi_name" placeholder="请输入展会名称" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group row align-items-center">
              <label class="form-label  text-left">展会时间：</label>
              <div class="">
                <el-date-picker v-model="rangeTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeExiDate" value-format="yyyy/MM/dd">
                </el-date-picker>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group row align-items-center">
              <label class="form-label  text-left">展会城市：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.exi_city" placeholder="请输入展会城市" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group row align-items-center">
              <label class="form-label  text-left">展会地址：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.exi_address" placeholder="请输入展会地址" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group row">
              <label class="form-label  text-left">大背景图：</label>
              <div class="">
                <button style="display:block;margin-bottom:6px;" class="btn btn-sm btn-primary" @click="uploadBanner1">
                  上传图片
                </button>
                <img class="banner-img" v-if="company.banner1" :src="company.banner1" />
              </div>
            </div>

            <div class="form-group row">
              <label class="form-label  text-left">小背景图：</label>
              <div class="">
                <button style="display:block;margin-bottom:6px;" class="btn btn-sm btn-primary" @click="uploadBanner2">
                  上传图片
                </button>
                <img class="banner-img" v-if="company.banner2" :src="company.banner2" />
              </div>
            </div> -->

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">联系人姓名：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.contactor"
                  placeholder="请输入联系人姓名" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">联系人电话：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.contactor_mobile"
                  placeholder="请输入联系人电话" />
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div class="d-flex">

        
            <div class="form-group  align-items-center">
              <label class="form-label  text-left">联系邮箱：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.email" placeholder="请输入公司邮箱" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group  align-items-center">
              <label class="form-label  text-left">公司网址：</label>
              <div class="">
                <input type="text" class="form-control form-control-300" v-model="company.web" placeholder="请输入公司网址" />
              </div>
              <div style="clear:both;"></div>
            </div>

            <div class="form-group  align-items-center" v-if="userInfo.company_type == '001'">
              <label class="form-label  text-left">排序序号：</label>
              <div class="">
                <input type="number" class="form-control form-control-300" v-model="seq" placeholder="请输入排序序号，越低越靠前" />
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
            <div class="form-group  align-items-center">
              <label class="form-label  text-left">公司介绍：</label>
              <div class="">
                <ContentEditor @changed="editChange" :content="company.introduction"></ContentEditor>
              </div>
              <div style="clear:both;"></div>
            </div>

            <button style="display:block;margin-bottom:6px;width:120px" class=" btn btn-sm btn-primary"
              @click="confirmCmp">
              保存公司信息
            </button>

          </div>
        </div>

      </div>
    </div>
    <FileUploader ref="logoUploader" />
    <FileUploader ref="bannerUploader1" />
    <FileUploader ref="bannerUploader2" />
    <FileUploader ref="videoUploader" />
  </div>
  <!-- END Page Content -->
</template>
<script>
import Interlige from "./IntelligentPerception";
import FileUploader from "./FileUploader";
import ContentEditor from "./el-GEditor";
import generator from "../utils/generator";
import { fetch } from "../utils/request";
import appsettings from "../utils/appsettings";
export default {
  props: {
    coid: null
  },
  data() {
    return {
      appsettings: appsettings,
      editType: "",
      isShow: false,
      company: {
        company_type: "002",
        show_mode: "0",
        is_support_join: 1
      },
      companyType: [
        {
          name: "主办方",
          code: "001"
        },
        {
          name: "展商",
          code: "002"
        }
        // { name: "媒体", code: 2 }
      ],
      provinces: [],
      cities: [],
      districts: [],
      userInfo: {},
      loadType: "",
      company_oid: "",
      role: "",
      rangeTime: [],
      videoProgress: 0,
      seq: null
    };
  },
  components: {
    FileUploader,
    ContentEditor,
    Interlige
  },
  created() {
    this.userInfo = this.$store.state.userInfo;
    this.role = this.$route.query.role;
  },
  mounted() {
    if (this.userInfo.company_type == "001") {
      if (!this.$route.query.company_oid) {
        this.editType = "新增";
      } else {
        this.editType = "编辑";
        this.company_oid = this.$route.query.company_oid;
        this.queryCmpInfo(this.company_oid);
      }
    } else {
      this.editType = "编辑";
      this.company_oid = this.userInfo.company_oid;
      this.queryCmpInfo(this.company_oid);
    }
    this.getAreaList();
    this.queryExhCInfo();
  },
  watch: {
    coid: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // 查询展会信息
          this.editType = newVal ? "编辑" : "新增";
          this.queryCmpInfo(newVal);
        }
      }
    }
  },
  methods: {
    queryCmpInfo(oid) {
      fetch("post", "exicompany/info", {
        oid
      }).then(res => {
        console.log(res.data);
        this.company = res.data;
        this.company.exi_id = this.$route.query.exi_oid;
        this.company.building_oid = this.$route.query.b_oid;
        if (this.company.zip != null && this.company.zip != "") {
          fetch("post", "utility/city/retrieve", {
            provincecode: this.company.zip.substring(0, 2) + "0000"
          })
            .then(res => {
              if (res.status == 0) {
                this.cities = res.data;
                //this.onSltCitiesChanged();
              }
            })
            .catch(err => { });
          fetch("post", "utility/district/retrieve", {
            citycode: this.company.zip.substring(0, 4) + "00"
          })
            .then(res => {
              if (res.status == 0) {
                this.districts = res.data;
                //this.onSltCitiesChanged();
              }
            })
            .catch(err => { });
        }
        this.company.isJoin = true;
        var date = this.company.exi_date ? this.company.exi_date.split(",") : ["", ""]
        this.rangeTime = date;
      });
    },
    queryExhCInfo() {
      if (this.$route.query.exi_oid != null && this.$route.query.b_oid != null) {
        fetch("post", "exiexhibitor/info", {
          exhibitor_oid: this.company_oid,
          exi_oid: this.$route.query.exi_oid,
          building_oid: this.$route.query.b_oid
        }).then(res => {
          console.log(res.data);
          this.seq = res.data.seq;
        });
      }
    },
    getProvinceCode: function () {
      if (this.company.zip == undefined || this.company.zip == "") {
        return "000000";
      } else {
        return this.company.zip.substring(0, 2) + "0000";
      }
    },
    getCityCode: function () {
      if (this.company.zip == undefined || this.company.zip == "") {
        return "000000";
      } else {
        return this.company.zip.substring(0, 4) + "00";
      }
    },

    queryCmpChange(e) {
      console.log("e---", e);
      if (e.oid != "isNew" && e.oid) {
        Object.assign(this.company, e, {
          exi_id: this.$route.query.exi_oid,
          building_oid: this.$route.query.b_oid,
          company_oid: e.oid
        });
      } else {
        e.exi_id = this.$route.query.exi_oid;
        e.building_oid = this.$route.query.b_oid;
        e.oid = "";
        this.company = {} = e;
      }
      let introduction = [], nodelist = [];
      if (e.introduction != null && e.introduction != "") {
        let reg = /\<p\>.*?\<\/p\>/g;
        nodelist = e.introduction.match(reg);//将富文本按照P标签拆分
        if (nodelist.length > 0) {
          let reg2 = /\<img src=\"(.*)?\" title=.*\/>/;
          let reg3 = /\<p\>(.*)?\<\/p\>/;
          nodelist.forEach(item => {
            var data = {};
            if (reg2.test(item)) {//判断P标签内是否有img标签，有则提取src
              let imgsrc = reg2.exec(item)[1];
              data.type = "image";
              data.value = imgsrc;
            } else {
              let textContent = reg3.exec(item)[1];
              data.type = "text",
                data.value = textContent;
            }
            introduction.push(data);
          });
          this.company.introduction = JSON.stringify(introduction);
        }
      }
      this.$forceUpdate()
      if (this.company.zip != null && this.company.zip != "") {
        fetch("post", "utility/city/retrieve", {
          provincecode: this.company.zip.substring(0, 2) + "0000"
        })
          .then(res => {
            if (res.status == 0) {
              this.cities = res.data;
              //this.onSltCitiesChanged();
            }
          })
          .catch(err => { });
        fetch("post", "utility/district/retrieve", {
          citycode: this.company.zip.substring(0, 4) + "00"
        })
          .then(res => {
            if (res.status == 0) {
              this.districts = res.data;
              //this.onSltCitiesChanged();
            }
          })
          .catch(err => { });
      }
    },
    completeInfo() {
      if (!this.company.company_name) {
        this.$message.warning("请输入公司名称");
        return;
      }
      var url = "/exicompany/query/fromqcc";
      fetch("post", url, this.company).then(res => {
        if (res.status == 0) {
          console.log("查询信息");
          this.company.zip = res.data.zip;
          this.company.address = res.data.address;
          this.company.introduction = '[{"type":"text","value":"' + res.data.introduction + '"}]';

          if (this.company.zip != null && this.company.zip != "" && this.cities.length == 0) {
            fetch("post", "utility/city/retrieve", {
              provincecode: this.company.zip.substring(0, 2) + "0000"
            })
              .then(res => {
                if (res.status == 0) {
                  this.cities = res.data;
                  //this.onSltCitiesChanged();
                }
              })
              .catch(err => { });
            fetch("post", "utility/district/retrieve", {
              citycode: this.company.zip.substring(0, 4) + "00"
            })
              .then(res => {
                if (res.status == 0) {
                  this.districts = res.data;
                  //this.onSltCitiesChanged();
                }
              })
              .catch(err => { });
          }



          window.open("https://www.qcc.com/web/search?key=" + this.company.company_name, "_blank");
        }
        else { console.log("查询信息失败"); }
      });
    },

    confirmCmp() {
      if (!this.company.company_name) {
        if (!this.$refs.Interlige.targetValue) {
          this.$message.warning("请输入公司名称");
          return;
        } else {
          this.company.company_name = this.$refs.Interlige.targetValue;
        }
      }
      if (this.rangeTime.length > 0) {
        this.company.exi_date = this.rangeTime.join(",");
      }
      if (this.company.tags != null && this.company.tags != "") {
        this.company.tags = this.company.tags.replace(/[\uff0c|\u3001]/g, ",");
      }
      var url = this.company.isJoin
        ? "/exicompany/update"
        : "/exicompany/exhibitor/create";
      this.company.exhibitor_oid = this.company.oid;
      this.company.company_oid = this.userInfo.company_oid;
      this.company.oid = this.company.isJoin ? this.company.oid : "";
      this.company.company_type = this.company.company_type || "002";
      this.company.exi_id = this.$route.query.exi_oid;
      this.company.building_oid = this.$route.query.b_oid;
      this.company.seq = this.seq;
      fetch("post", url, this.company).then(res => {
        if (res.status == 0) {
          if (this.userInfo.company_type == "001") {
            this.$router.go(-1);
          } else {
            this.$message.success("编辑公司信息成功");
          }
        }
      });
    },

    getAreaList() {
      fetch("post", "utility/province/retrieve")
        .then(res => {
          if (res.status == 0) {
            this.provinces = res.data;
          }
        })
        .catch(err => { });
    },

    onProvinceChange(e) {
      //获取该省城市列表
      this.company.zip = e.currentTarget.value;
      var body = {
        provincecode: e.currentTarget.value
      };
      fetch("post", "utility/city/retrieve", body)
        .then(res => {
          if (res.status == 0) {
            this.cities = res.data;
            //this.onSltCitiesChanged();
          }
        })
        .catch(err => { });
    },

    onCityChange(e) {
      //获取区列表
      this.company.zip = e.currentTarget.value;
      var body = {
        citycode: e.currentTarget.value
      };
      fetch("post", "utility/district/retrieve", body)
        .then(res => {
          if (res.status == 0) {
            this.districts = res.data;
            //this.onSltCitiesChanged();
          }
        })
        .catch(err => { });
    },

    cityChange(e) {
      // this.company.zip = value[value.length - 1];
      this.company.zip = e.currentTarget.value;
    },

    changeType() { },
    // 编辑文章内容
    editChange(content) {
      this.company.introduction = content;
    },
    // 上传大背景图
    uploadBanner1() {
      this.loadType = "banner1";
      this.$refs.bannerUploader1.uploadNewFiles(
        {
          url: "utility/upload",
          multiple: false
        },
        this.fileUploading,
        this.fileUploaded
      );
    },
    // 上传小背景图
    uploadBanner2() {
      this.loadType = "banner2";
      this.$refs.bannerUploader2.uploadNewFiles(
        {
          url: "utility/upload",
          multiple: false
        },
        this.fileUploading,
        this.fileUploaded
      );
    },
    uploadLogo() {
      this.loadType = "logo";
      this.$refs.logoUploader.uploadNewFiles(
        {
          url: "utility/upload",
          multiple: false
        },
        this.fileUploading,
        this.fileUploaded
      );
    },
    uploadVideo() {
      this.loadType = "video";
      this.videoProgress = 0;
      this.$refs.videoUploader.uploadNewFiles(
        {
          url: "utility/upload",
          multiple: false
        },
        this.fileUploading,
        this.fileUploaded
      );
    },
    // 题目附件上传中
    fileUploading: function (e) {
      this.videoProgress = e.progress;
    },
    // 题目附件上传成功
    fileUploaded: function (e, file) {
      if (this.loadType == "logo") {
        this.$set(this.company, "logo", this.appsettings.up_prefix + e);
      }
      if (this.loadType == "video") {
        this.$set(this.company, "video", this.appsettings.up_prefix + e);
      }
      if (this.loadType == "banner1") {
        this.$set(this.company, "banner1", this.appsettings.up_prefix + e);
      }
      if (this.loadType == "banner2") {
        this.$set(this.company, "banner2", this.appsettings.up_prefix + e);
      }
      // this.loading.close();
      this.$message.success("上传成功！");
    },
    // 修改展会时间
    changeExiDate(e) {

    },
    del_video() {
      this.$set(this.company, "video", "");
    }
  }
};
</script>
<style lang="scss" scoped>
.search-input {
  border: none;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 0;
}

.form-control form-control-300:focus {
  box-shadow: none;
}

.banner-img {
  height: 160px;
  width: auto;
  max-width: 100%;
}

.mb-3 {
  margin-bottom: 2rem !important;
}</style>



// WEBPACK FOOTER //
// src/components/editCompany.vue